(function () {
  'use strict';

  angular.module('checker.filters', []);

})();
